// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.terms-and-conditions-container {
  max-height: 650px;
  padding: 1.5rem;
  overflow: auto !important;
}
.terms-and-conditions-container a {
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/compliance/terms-and-conditions/terms-and-conditions.component.scss","webpack://./../../01.%20UI/NgHsSurveyClient/src/app/shared/compliance/terms-and-conditions/terms-and-conditions.component.scss"],"names":[],"mappings":"AAAA;EAEE,iBAAA;EACA,eAAA;EACA,yBAAA;ACAF;ADCE;EACE,qBAAA;ACCJ","sourcesContent":[".terms-and-conditions-container\r\n{\r\n  max-height: 650px;\r\n  padding: 1.5rem;\r\n  overflow: auto !important;\r\n  a {\r\n    text-decoration: none;\r\n  }\r\n}\r\n\r\n\r\n",".terms-and-conditions-container {\n  max-height: 650px;\n  padding: 1.5rem;\n  overflow: auto !important;\n}\n.terms-and-conditions-container a {\n  text-decoration: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
